import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Availability } from '../../../models/availability';
import { parse } from 'date-fns';
import { Product } from '../../../models';
import { DateUtilService, GungLanguageConfigService } from 'gung-common';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'lib-availability-modal',
    templateUrl: './availability-modal.component.html',
    styleUrls: ['./availability-modal.component.css'],
    standalone: false
})
export class AvailabilityModalComponent implements OnInit{
  product: Product;
  availability: Availability;
  customerOrders: any[] = [];
  purchaseOrders: any[] = [];
  localeLang: string;
  stockId?: string;

  constructor(
    public activeModal: NgbActiveModal,
    public dateUtilService: DateUtilService,
    protected translateService: TranslateService,
    protected languageConfigService: GungLanguageConfigService
  ) {
    this.localeLang = languageConfigService.getLanguages().find(
      lang => lang.short === translateService.currentLang
    )?.locale || 'en-GB';
  }

  ngOnInit(): void {
    if(this.availability?.extra?.transactions){
      this.customerOrders = this.availability?.extra?.transactions.filter(o => {
        return o.transactionType === 'CO'; //Customer order
      });
      this.purchaseOrders = this.availability?.extra?.transactions.filter(o => {
        return o.transactionType === 'PO'; //Customer order
      });
    }
  }

  parseDate(date: string): Date {
    return parse(date, 'yyMMdd', new Date());
  }

  parseFloat(value): number {
    return parseFloat(value);
  }
}
